export default __webpack_public_path__ + "static/media/Eye.72c4c362.svg";